import { AuthenticationBearerJWT } from 'chezy-inventory-backend/bin/auth/AuthenticationContext'
import { Inventory } from 'chezy-inventory-backend/bin/database/types/Inventory'
import { createContext } from 'react'

export const AuthContext = createContext<{
  jwt?: string
  tokenData?: AuthenticationBearerJWT | undefined
  setJwt: (jwt: string | undefined) => void
  setTokenData: (tokenData: AuthenticationBearerJWT | undefined) => void
  permittedInventores: Inventory[]
  setPermittedInventories: (invs: Inventory[]) => void
  authLoading: boolean
  setAuthLoading: (isLoading: boolean) => void
  reloadUserData: () => void
}>({
  jwt: undefined,
  tokenData: undefined,
  permittedInventores: [],
  setJwt: (jwt: string | undefined) => {
    /* */
  },
  setTokenData: (tokenData: AuthenticationBearerJWT | undefined) => {
    /* */
  },
  setPermittedInventories: (invs: Inventory[]) => {
    /* */
  },
  authLoading: true,
  setAuthLoading: (loading: boolean) => {
    /* */
  },
  reloadUserData: () => {
    /* */
  },
})
